import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UpdateExternalToolCategoryDto } from '@inference.engine/api-client/web';
import { notificationService } from '@/lib/services/notification.service';
import { i18n } from '@/shared/i18n';
import { logger } from '@/lib/utils/logger';
import { updateExternalToolCategory } from '../api';
import { EXTERNAL_TOOL_CATEGORIES_QUERY_KEY } from './queryKeys';

export const useUpdateExternalToolCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      categoryId,
      body,
      workspaceId,
    }: {
      categoryId: string;
      body: UpdateExternalToolCategoryDto;
      workspaceId?: string;
    }) => updateExternalToolCategory(categoryId, body, workspaceId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [EXTERNAL_TOOL_CATEGORIES_QUERY_KEY] });
      notificationService.showSuccess(
        i18n.t('admin:externalTool.useUpdateExternalToolCategory.categoryUpdated'),
      );
    },
    onError: (error) => {
      notificationService.showError(
        i18n.t('admin:externalTool.useUpdateExternalToolCategory.failedToUpdateCategory'),
      );
      logger.error('Failed to update category:', error);
    },
  });
};
